// extracted by mini-css-extract-plugin
module.exports = {"h2Class":"H2_h2Class__DK0U1"};